import { Technology } from "@/types/technologies";
import { api } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

type TechnologyGroups = {
  [key: string]: Technology[];
};

export function useGroupedTechnologies() {
  return useQuery({
    queryKey: ["technologies"],
    queryFn: () =>
      api
        .get("apps/sales/configuration/technologies/grouped")
        .json<TechnologyGroups>(),
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}

export function useTechnologyGroup(group: string) {
  const { data: technologies, ...rest } = useGroupedTechnologies();
  if (group === "other") {
    return {
      data: Object.entries(technologies || {}).reduce(
        (acc, [key, value]) => {
          acc.push(...value.map((v) => ({ ...v, category: key })));
          return acc;
        },
        [] as { category: string; technology: string; count: number }[],
      ),
      ...rest,
    };
  }
  return { data: technologies?.[group] ?? [], ...rest };
}
